var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-snotify'),_c('navbar',{directives:[{name:"show",rawName:"v-show",value:(
      _vm.isLoggedSGQIn &&
      _vm.currentRouteName !== 'NotFound' &&
      _vm.currentRouteName !== 'Unauthorized'
    ),expression:"\n      isLoggedSGQIn &&\n      currentRouteName !== 'NotFound' &&\n      currentRouteName !== 'Unauthorized'\n    "}]}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }